module.exports = __webpack_public_path__ + "static/img/logo-b.de597a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-b.png
// module id = ocnz
// module chunks = 25